import { http } from '@/http/axios.js'
// 分页列表
export function getListAPI(params) {
  return http({
    url: '/admin/storeGoodsSeries/page',
    method: 'get',
    params
  })
}
// 全量列表（下拉源，支持 categoryId 过滤）
export function getSeriesListAPI(params) {
  return http({
    url: '/admin/storeGoodsSeries/list',
    method: 'get',
    params
  })
}
// 分类下拉（门店商品分类 /list）
export function getCategoryListAPI(params) {
  return http({
    url: '/admin/storeGoodsCategory/list',
    method: 'get',
    params
  })
}
// 品牌下拉
export function getBrandListAPI(params) {
  return http({
    url: '/admin/oprt/goodsBrand/enumList',
    method: 'get',
    params
  })
}
// detail
export function getDetailAPI(id) {
  return http({
    url: '/admin/storeGoodsSeries/detail',
    method: 'get',
    params: { id }
  })
}
// add
export function addAPI(data) {
  return http({
    url: '/admin/storeGoodsSeries/add',
    method: 'post',
    data
  })
}
// edit
export function editAPI(data) {
  return http({
    url: '/admin/storeGoodsSeries/edit',
    method: 'post',
    data
  })
}
// delete
export function deleteAPI(id) {
  return http({
    url: '/admin/storeGoodsSeries/delete',
    method: 'post',
    data: { id }
  })
}
